import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import CTextBox from '../../../../Common/CTextBox';
import CDatePicker from '../../../../Common/CDatePicker';
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';
import Picker from '../../../../Common/Picker';
import { Col, Row } from 'react-bootstrap';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import { __OBJECT_STRUCTURE_GetAction } from '../../../../../common/ObjectStructures/sKPI';
import List from '../../../../Templates/List';
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListGapActions } from '../../../../../hooks/services/sKPI/useOfGAP';
import { saveActionsByElementId } from '../../../../../services/sKPI/gap.service';
import moment from 'moment';
import { enum__GapActionTypes, __ActionStatus, __MessageTypes } from '../../../../../common/Dictionaries';
import GapActionCard from '../GapActionCard/GapActionCard';
import PropTypes from 'prop-types';
import MessageBox from '../../../../Common/Message/MessageBox';
import { isNullOrEmpty, showMessage } from '../../../../../common/Helpers';
import CValidator from '../../../../Common/CValidator';
import CLabel from '../../../../Common/CLabel';
import { Dropdown, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import { useContext } from 'react';
import GapAppContext from '../../../../../GapAppContext';
import { useGetPrivilegePartyMembers, useGetPrivilegePartyMembersCustom } from '../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { cloneDeep } from 'lodash-es';

const SidePanelAddAction = (props) => {
    const { t } = useTranslation();
    const contextGap = useContext(GapAppContext);


    const { 
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_CauseId = null,
        inputParam_CauseName = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_EditMode = null,

        inputParam_RevisionDataserie = null,
    } = props;
    
    const inputParam_ActionsList =  inputParam_RevisionDataserie.l_causes.filter(x => x.gapCauseId === inputParam_CauseId)

    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidBeginDate      : false,
        isInValidEndDate        : false,
        isInvalidAction         : false,
        isInvalidTitle          : false,
        isInvalidOwner          : false,
        isInvalidExecutor       : false,
        isInvalidStatus   : false,
    })

    const [objAction, setObjAction] = useState(__OBJECT_STRUCTURE_GetAction());
    const [actionList, setActionist] = useState(__OBJECT_STRUCTURE_GetList(10, inputParam_ActionsList));

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [elementUserOwnerList, setElementUserOwnerList] = useState(null);
    useGetPrivilegePartyMembersCustom(inputParam_RevisionDataserie.elementId, elementUserOwnerList, setElementUserOwnerList, false, null, inputParam_IsPanelOpen, true)
    
    const [elementUserExecutorList, setElementUserExecutorList] = useState(null);
    useGetPrivilegePartyMembersCustom(inputParam_RevisionDataserie.elementId, elementUserExecutorList, setElementUserExecutorList, false, null, inputParam_IsPanelOpen, true)

    useGetListGapActions(inputParam_GapAnalyzeId, null, null, null, inputParam_CauseId, null, actionList, setActionist, inputParam_IsPanelOpen)

    const actionStatusList = __ActionStatus.map(function(item) { return { key: item.key, text:  t(item.text) } });

    const validateForm = (obj) => {
        const isInvalidOwner = isNullOrEmpty(obj.owner);
        //const isInvalidExecutor = isNullOrEmpty(obj.executor);
        const isInvalidExecutor = false
        const isInvalidTitle = isNullOrEmpty(obj.title);
        const isInvalidAction = isNullOrEmpty(obj.action);

        const isInvalidStatus = obj.statusId <= 1 ? false : (isNullOrEmpty(obj.beginDate) || isNullOrEmpty(obj.endDate)) ;

        const isInvalidDateDifference1 = moment(obj.beginDate) > moment(obj.endDate);
        const isInvalidDateDifference2 = moment(obj.endDate) < moment(obj.beginDate);

        if (isInvalidDateDifference1) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-startupperthanend'))
        }
        if (isInvalidDateDifference2) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-endlowerthanstart'))
        }

        setObjIsValidForm({
            isInvalidAction     : isInvalidAction,
            isInvalidTitle      : isInvalidTitle,
            isInvalidOwner      : isInvalidOwner,
            isInvalidExecutor   : isInvalidExecutor,
            isInvalidStatus   : isInvalidStatus,
        })

        return !isInvalidOwner && !isInvalidExecutor && !isInvalidTitle && !isInvalidAction && !isInvalidStatus;
    };

    const onAddEditAction = (e) => {
        let formIsValid = validateForm(objAction);

        if (formIsValid === true) {
            
            if (objAction.id === null) {
                objAction.id = 0;
                objAction.statusId = 1;
                objAction.gapRevisionId = inputParam_GapRevisionId;
                objAction.deactivate = false;
                objAction.gapCauseId = inputParam_CauseId;
            }

            const aux_objAction = cloneDeep(objAction);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_CAUSE).then((response) => {
                if (response.data.succeeded) {
                    setActionist && setActionist(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data : response.data.data
                    }));

                    inputParam_RevisionDataserie.l_causes.forEach(element => {
                        if (element.id === objAction.gapCauseId) {
                            element.l_action = response.data.data
                        }
                    });

                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(revisionDataserie => {
                        revisionDataserie.l_causes.forEach(cause => {
                            if (cause.id === objAction.gapCauseId) {
                                revisionDataserie.l_causes = inputParam_RevisionDataserie.l_causes
                            }
                        });
                    });

                    contextGap.dataserieFullData.set && contextGap.dataserieFullData.set(prevState => ({
                        ...prevState,
                        revisionDataserieFullList: contextGap.dataserieFullData.value.revisionDataserieFullList,
                        fireUpdateLastAction: true                  
                    }))
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onEditActionFromListClick = (item) => {
        ManipulateRowButtonsDisplay(item.id)
        setObjAction({
            id: item.id,
            gapCauseId: item.gapCauseId,
            gapRevisionId: item.gapRevisionId,
            owner: item.owner,
            executor: item.executor,
            title: item.title,
            action: item.action,
            statusId: item.statusId,
            beginDate: item.beginDate,
            endDate: item.endDate,
        });

        let clear = false;
        setterUserFromListToForm(item, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(item, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    }

    const setterUserFromListToForm = (item, setter, fieldFromList, fieldFromForm, list, clear) => {
        list.forEach(x => {
            x.checked = false;
            if (!clear) {
                if (x[fieldFromList] === item[fieldFromForm]) {
                    x.checked = item.checked !== undefined ? item.checked : true;
                }
            }
        })
        setter(list)
    }

    const onCancelRowClick = (item) => {
        ManipulateRowButtonsDisplay(item.id);
        setObjAction(__OBJECT_STRUCTURE_GetAction())

        let clear = true;
        setterUserFromListToForm(item, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(item, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    };

    const ManipulateRowButtonsDisplay = (itemId) => {
        let elementsRowCancel = document.getElementsByClassName(`btnMantEdit`);
        let elementsRowEdit = document.getElementsByClassName(`btnMantCancel`);

        let elementBtnMantEdit = document.getElementById(`btnMantEdit${itemId}`);
        let elementBtnMantCancel = document.getElementById(`btnMantCancel${itemId}`);
        
        const isHiddenItem = elementBtnMantEdit.style.display === "none";

        if (isHiddenItem) {
            elementBtnMantCancel.style.display = "none";
            elementBtnMantEdit.style.display = "block";
        }
        else {
            Array.prototype.forEach.call(elementsRowCancel, function(el) {
                el.style.display = "block";
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                el.style.display = "none";
            });

            elementBtnMantCancel.style.display = "block";
            elementBtnMantEdit.style.display = "none";
        }
    }

    const onDeleteActionFromListClick = (item) => {
        if (item.id > 0) {
            item.deactivate = true;

            const aux_objAction = cloneDeep(item);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_CAUSE).then((response) => {
                if (response.data.succeeded) {

                    setActionist(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data.data
                    }));

                    inputParam_RevisionDataserie.l_causes.forEach(element => {
                        if (element.id === inputParam_CauseId) {
                            element.l_action = response.data.data
                        }
                    });

                    contextGap.dataserieFullData.value.revisionDataserieFullList.forEach(item => {
                        if (item.gapRevisionId === inputParam_GapRevisionId && item.gapAnalyzeElementId === inputParam_RevisionDataserie.gapAnalyzeElementId) {
                                item.l_cause = inputParam_RevisionDataserie.l_causes
                        }
                    });

                    contextGap.dataserieFullData.set && contextGap.dataserieFullData.set(prevState => ({
                        ...prevState,
                        revisionDataserieFullList: contextGap.dataserieFullData.value.revisionDataserieFullList,
                        fireUpdateLastAction: true
                    }))
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            setActionist(prevState => ({
                ...prevState,
                data: actionList.data.filter(x => x.id !== item.id)
            }));
        }
    }

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        showMessage(setMessageConfig, false, null, null)
        setActionist(__OBJECT_STRUCTURE_GetList())
        setObjAction(__OBJECT_STRUCTURE_GetAction())

        let clear = true;
        setterUserFromListToForm(null, setElementUserOwnerList, 'username', 'owner', elementUserOwnerList, clear)
        setterUserFromListToForm(null, setElementUserExecutorList, 'username', 'executor', elementUserExecutorList, clear)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="fishboneAddAction"
                            data={ actionList }
                            setData={ setActionist } />
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox  
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const setterControlValue = (controlValue, controlName) => {
        setObjAction(prevState => ({
            ...prevState,
            [controlName]: controlValue,
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidTitle: controlValue === ""
        }));
    }

    const setterControlTextAreaValue = (e) => {
        const { value } = e.currentTarget; // <-- moved outside asynchronous context

        setObjAction(prevState => ({
            ...prevState,
            action: value,
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidAction: value === ""
        }));
    }

    const setterControlDatePickerValue = (value, controlName) => {
        if (controlName === "beginDate") {
            if (moment(value) > moment(objAction.endDate)) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-startupperthanend'))
            }
            else {
                setObjAction(prevState => ({
                    ...prevState,
                    [controlName]: moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                }));
            }

            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidBeginDate: isNullOrEmpty(value)
            }));
        }
        else if (controlName === "endDate") {
            if (moment(value) < moment(objAction.beginDate)) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-endlowerthanstart'))
            }
            else {
                setObjAction(prevState => ({
                    ...prevState,
                    [controlName]: moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                }));
            }

            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidEndDate: isNullOrEmpty(value)
            }));
        }
    }

    const onChangePickerOwner = (currentNode, selectedNodes) => {
        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserOwnerList, 'username', 'username', elementUserOwnerList, clear)
        setterUserFromListToForm(currentNode, setElementUserExecutorList, 'username', 'username', elementUserExecutorList, clear)

        setObjAction(prevState => ({
            ...prevState,
            owner: currentNode.username,
            executor: currentNode.username
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidOwner: currentNode.username === "",
            isInvalidExecutor: currentNode.username === ""
        }));

        showMessage(setMessageConfig, false, null, null)
    };

    const onChangePickerExecutor = (currentNode, selectedNodes) => {
        setObjAction(prevState => ({
            ...prevState,
            executor: currentNode.username
        }));

        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserExecutorList, 'username', 'username', elementUserExecutorList, clear)

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidExecutor: currentNode.username === ""
        }));
        
        showMessage(setMessageConfig, false, null, null)
    };

    const onChangeActionState = (ev, item) => {
        setObjAction(prevState => ({
            ...prevState,
            statusId: item.key
        }));
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-addaction') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row>
                    {
                        inputParam_CauseName &&
                        <Col xs={12} xl={12} className="mt-3">
                            <CLabel labelText={ t('data-lang-lbl-cause') } labelValue={inputParam_CauseName} />
                        </Col>
                    }
                    <Col xs={12} xl={6} className="mt-3">
                        <Picker
                            data={ elementUserOwnerList !== null ? elementUserOwnerList : [] }
                            mode="simpleSelect"
                            className="dropdown-checkbox remove-position"
                            texts={{ placeholder: t('data-lang-lbl-chooses') }}
                            onChange={ onChangePickerOwner }
                            labelText={ t('data-lang-lbl-responsible') }
                            refresh={true}
                        />
                        <CValidator isInValid={ objIsValidForm.isInvalidOwner } />
                    </Col>
                    <Col xs={12} xl={6} className="mt-3">
                        <Picker
                            data={ elementUserExecutorList !== null ? elementUserExecutorList : [] }
                            mode="simpleSelect"
                            className="dropdown-checkbox remove-position"
                            texts={{ placeholder: t('data-lang-lbl-chooses') }}
                            onChange={ onChangePickerExecutor }
                            labelText={ t('data-lang-lbl-executor') }
                            refresh={true}
                        />
                    </Col>
                    <Col xl={12} className="mt-3">
                        <CTextBox
                            labelText={ t('data-lang-lbl-title') }
                            controlValue={ objAction.title }
                            textBoxName={'title'}
                            maxLength={50}
                            setterControlValue={setterControlValue}
                        />
                        <CValidator isInValid={ objIsValidForm.isInvalidTitle } />
                    </Col>
                    <Col xs={12} className="mt-3">
                        <CTextAreaSimple
                            editMode={true}
                            maxLength={250}
                            labelText={ t('data-lang-lbl-action') }
                            controlValue={ objAction.action } 
                            textBoxName={'action'}
                            setterControlValue={setterControlTextAreaValue}
                        />
                        <CValidator isInValid={ objIsValidForm.isInvalidAction } />
                    </Col>
                    <Col xs={12} xl={6} className="mt-3">
                        <CDatePicker 
                            controlName={ "beginDate" } 
                            controlValue={ objAction && objAction.beginDate } 
                            setterControlValue={ setterControlDatePickerValue } 
                            isInValid={ objIsValidForm.isInValidBeginDate } 
                            labelText={ t('data-lang-lbl-startdate') } 
                        />
                    </Col>
                    <Col xs={12} xl={6} className="mt-3">
                        <CDatePicker 
                            controlName={ "endDate" } 
                            controlValue={ objAction && objAction.endDate } 
                            setterControlValue={ setterControlDatePickerValue } 
                            isInValid={ objIsValidForm.isInValidEndDate } 
                            labelText={ t('data-lang-lbl-enddate') } 
                        />
                    </Col>
                </Row>
                {
                    objAction.id !== null && objAction.id !== 0 &&
                    <Row className='pt-2'>
                        <Col>
                            <CLabel labelText={ t('data-lang-lbl-status') } />
                            <Dropdown
                                placeholder={t('data-lang-placeholder-selectoption')}
                                options={actionStatusList}
                                selectedKey={objAction.statusId}
                                onChange={onChangeActionState}
                                checkable
                                styles={ {title: { height: "27px" }} }
                                className="mb-1"
                            />
                            <CValidator isInValid={objIsValidForm.isInvalidStatus} isInvalidText={!objIsValidForm.isInvalidStatus ? "" : null} inValidText={t('data-lang-msg-actiondatesrequiredtochangestatus')} /> 
                        </Col>
                    </Row>
                }
                <Row className="mb-3">
                    <Col xl={12} className="mt-3">
                        <PrimaryButton onClick={onAddEditAction} text={(objAction.id === null || objAction.id === 0)? t('data-lang-btn-add') : t('data-lang-btn-edit')} />
                    </Col>
                </Row>
                    <ScrollablePane
                        styles={{
                            root: { height: "350px", position: "relative" },
                            contentContainer:{overflowX: "hidden"}
                        }}
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        scrollContainerFocus={true}
                    >
                        <List
                            listLocalStoragePageSizeVariableName="fishboneAddAction"
                            manipulateLocalData={ true }
                            setData={setActionist}
                            showHeaders={false}
                            data={actionList}
                            className="overflow-hidden no-compact-list"
                            columns={[
                                {  
                                    key: 'title',
                                    name: t('data-lang-lbl-data'),
                                    fieldName: 'title',
                                    onRender:(item, row) => {
                                        return <GapActionCard
                                                    inputParam_EditMode={false}
                                                    inputParam_GapElementId={'#2'}
                                                    inputParam_ActionItem={item}
                                                    inputParam_ShowSeparatorStyle={false}
                                                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                    inputParam_GapRevisionId={inputParam_GapRevisionId}
                                                />
                                    }
                                },{  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    minWidth: 50,
                                    maxWidth: 50,
                                    onRender:(item, row) => {
                                        return  <>
                                                {
                                                    inputParam_EditMode === true &&<div className='d-flex mt-3'>           
                                                        {
                                                            item.id > 0 && 
                                                            <>
                                                                <ActionButton className="btnMantEdit" id={`btnMantEdit${item.id}`} iconProps={{ iconName: 'Edit' }} onClick={() => onEditActionFromListClick(item)} allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton className="btnMantCancel" id={`btnMantCancel${item.id}`} style={{display: "none"}} iconProps={{ iconName: 'Cancel' }} onClick={() => onCancelRowClick(item)} allowDisabledFocus >
                                                                </ActionButton>
                                                            </>
                                                        }
                                                        <ActionButton id={`btnMantDelete${item.id}`} iconProps={{ iconName: 'Delete' }} onClick={() => onDeleteActionFromListClick(item)} allowDisabledFocus >
                                                        </ActionButton>
                                                    </div>
                                                }
                                                </>
                                    }
                                } 

                            ]}
                        />
                    </ScrollablePane>
            </Panel>
        </div>
    );
};

SidePanelAddAction.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number.isRequired,
    inputParam_CauseId: PropTypes.number.isRequired,
    inputParam_CauseName: PropTypes.string.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
};

export default SidePanelAddAction;